export const STATUS_SWITCH_ON = 'status_switch_on'
export const STATUS_SWITCH_OFF = 'status_switch_off'
export const STATUS_SWITCH_PARTIAL_ON = 'status_switch_partial_on'
